module.exports = ""


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main